import React, { useState } from 'react';

// Mock auth hook for standalone use
const useAuth = () => ({
  organizationName: 'My Organization',
  user: { email: 'admin@example.com' }
});

export default function SheetRecordsWorking() {
  const { organizationName, user } = useAuth();

  const [searchFrom, setSearchFrom] = useState('');
  const [searchTo, setSearchTo] = useState('');
  const [showEntries, setShowEntries] = useState('All');
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);

  // Mock data - empty as per original
  const allData = [];

  const handleSort = (key) => {
    setSortConfig(prev =>
      prev.key === key
        ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { key, direction: 'asc' }
    );
  };

  const handleSelectAll = (e) => {
    setSelectedRows(e.target.checked ? allData.map((_, i) => i) : []);
  };

  const handleRowSelect = (idx) => {
    setSelectedRows(prev =>
      prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]
    );
  };

  const handleDelete = () => {
    if (selectedRows.length === 0) return;
    alert(`Delete ${selectedRows.length} selected record(s)?`);
  };

  const handleSearch = () => {
    // search logic here
  };

  const SortIcon = ({ col }) => (
    <span className="inline-flex flex-col ml-1 align-middle">
      <svg
        className={`w-2.5 h-2.5 ${sortConfig.key === col && sortConfig.direction === 'asc' ? 'text-blue-600' : 'text-gray-400'}`}
        viewBox="0 0 10 6" fill="currentColor"
      >
        <path d="M5 0L10 6H0z" />
      </svg>
      <svg
        className={`w-2.5 h-2.5 mt-0.5 ${sortConfig.key === col && sortConfig.direction === 'desc' ? 'text-blue-600' : 'text-gray-400'}`}
        viewBox="0 0 10 6" fill="currentColor"
      >
        <path d="M5 6L0 0H10z" />
      </svg>
    </span>
  );

  const columns = ['S.No.', 'Date', 'Shift', 'Employee', 'Entry Source', 'Modules', 'Action', 'User Log Details'];
  const colKeys = ['sno', 'date', 'shift', 'employee', 'entry_source', 'modules', 'action', 'user_log'];

  return (
    <div className="min-h-screen" style={{ background: '#f0f2f7', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Top Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '14px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{
            width: 42, height: 42, borderRadius: '50%',
            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontSize: 18, flexShrink: 0
          }}>
            <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#111827', letterSpacing: '-0.3px' }}>
              Sheet Records
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 1 }}>
              Entries &amp; Log Management
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>{organizationName || 'Loading...'}</div>
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
            {user?.email ? `Logged in as: ${user.email}` : 'SUPER ADMIN'}
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '8px 28px' }}>
        <nav style={{ fontSize: 13, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>Dashboard</span>
          <span style={{ color: '#d1d5db' }}>›</span>
          <span style={{ color: '#111827', fontWeight: 600 }}>Entries</span>
        </nav>
      </div>

      <div style={{ padding: '24px 28px' }}>

        {/* Entry Form Card - styled like Interest Transactions */}
        <div style={{
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
          marginBottom: 22,
          overflow: 'hidden'
        }}>
          {/* Blue header bar */}
          <div style={{
            background: 'linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%)',
            padding: '14px 22px',
            display: 'flex',
            alignItems: 'center',
            gap: 10
          }}>
            <svg width="20" height="20" fill="none" stroke="#fff" viewBox="0 0 24 24" strokeWidth={2}>
              <circle cx="12" cy="12" r="10" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3" />
            </svg>
            <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, letterSpacing: '-0.2px' }}>
              Search Entries
            </span>
            <span style={{
              marginLeft: 8,
              background: 'rgba(255,255,255,0.2)',
              color: '#fff',
              fontSize: 11,
              fontWeight: 700,
              padding: '2px 10px',
              borderRadius: 4,
              letterSpacing: 1
            }}>FILTER FORM</span>
          </div>

          {/* Search Fields */}
          <div style={{ padding: '20px 22px', display: 'flex', alignItems: 'flex-end', gap: 20, flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                FROM DATE *
              </label>
              <input
                type="date"
                value={searchFrom}
                onChange={e => setSearchFrom(e.target.value)}
                style={{
                  border: '1.5px solid #d1d5db', borderRadius: 7, padding: '8px 12px',
                  fontSize: 13, outline: 'none', width: 170,
                  transition: 'border-color 0.2s',
                  color: '#374151'
                }}
                onFocus={e => e.target.style.borderColor = '#2563eb'}
                onBlur={e => e.target.style.borderColor = '#d1d5db'}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                TO DATE *
              </label>
              <input
                type="date"
                value={searchTo}
                onChange={e => setSearchTo(e.target.value)}
                style={{
                  border: '1.5px solid #d1d5db', borderRadius: 7, padding: '8px 12px',
                  fontSize: 13, outline: 'none', width: 170,
                  transition: 'border-color 0.2s',
                  color: '#374151'
                }}
                onFocus={e => e.target.style.borderColor = '#2563eb'}
                onBlur={e => e.target.style.borderColor = '#d1d5db'}
              />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={handleSearch}
                style={{
                  background: 'linear-gradient(135deg, #f97316, #ea580c)',
                  color: '#fff', border: 'none', borderRadius: 8,
                  padding: '9px 22px', fontWeight: 700, fontSize: 13,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 7,
                  boxShadow: '0 2px 8px rgba(249,115,22,0.35)',
                  transition: 'transform 0.1s, box-shadow 0.1s'
                }}
                onMouseDown={e => { e.currentTarget.style.transform = 'scale(0.97)'; }}
                onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)'; }}
              >
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Search
              </button>
              <button
                onClick={() => { setSearchFrom(''); setSearchTo(''); }}
                style={{
                  background: '#fff', color: '#6b7280',
                  border: '1.5px solid #d1d5db', borderRadius: 8,
                  padding: '9px 18px', fontWeight: 600, fontSize: 13,
                  cursor: 'pointer'
                }}
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        {/* Stats Row - like Interest Transactions summary cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 22 }}>
          {[
            { label: 'TOTAL ENTRIES', value: '0', color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
            { label: 'TOTAL EMPLOYEES', value: '0', color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
            { label: 'TOTAL SHIFTS', value: '0', color: '#9333ea', bg: '#faf5ff', border: '#e9d5ff' },
            { label: 'TOTAL MODULES', value: '0', color: '#111827', bg: '#f9fafb', border: '#e5e7eb' },
          ].map(({ label, value, color, bg, border }) => (
            <div key={label} style={{
              background: bg,
              border: `1.5px solid ${border}`,
              borderRadius: 12,
              padding: '18px 20px',
            }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.7, marginBottom: 8 }}>
                {label}
              </div>
              <div style={{ fontSize: 28, fontWeight: 800, color, letterSpacing: '-1px' }}>
                {value}
              </div>
            </div>
          ))}
        </div>

        {/* Table Card */}
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>

          {/* Table Controls */}
          <div style={{
            padding: '14px 20px',
            borderBottom: '1px solid #f3f4f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <button
                onClick={handleDelete}
                style={{
                  background: selectedRows.length > 0 ? '#fee2e2' : '#fafafa',
                  color: selectedRows.length > 0 ? '#dc2626' : '#9ca3af',
                  border: `1.5px solid ${selectedRows.length > 0 ? '#fca5a5' : '#e5e7eb'}`,
                  borderRadius: 7, padding: '7px 16px',
                  fontWeight: 700, fontSize: 13,
                  cursor: selectedRows.length > 0 ? 'pointer' : 'not-allowed',
                  display: 'flex', alignItems: 'center', gap: 6,
                  transition: 'all 0.2s'
                }}
              >
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete {selectedRows.length > 0 ? `(${selectedRows.length})` : ''}
              </button>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#374151', fontWeight: 500 }}>Show</span>
                <select
                  value={showEntries}
                  onChange={e => setShowEntries(e.target.value)}
                  style={{
                    border: '1.5px solid #d1d5db', borderRadius: 7,
                    padding: '6px 10px', fontSize: 13, color: '#374151',
                    outline: 'none', background: '#fff'
                  }}
                >
                  <option>All</option>
                  <option>10</option>
                  <option>25</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span style={{ fontSize: 13, color: '#374151', fontWeight: 500 }}>entries</span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, color: '#374151', fontWeight: 500 }}>Search:</span>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="Search party, type, notes..."
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                  style={{
                    border: '1.5px solid #d1d5db', borderRadius: 7,
                    padding: '7px 36px 7px 12px', fontSize: 13,
                    width: 240, outline: 'none', color: '#374151'
                  }}
                  onFocus={e => e.target.style.borderColor = '#2563eb'}
                  onBlur={e => e.target.style.borderColor = '#d1d5db'}
                />
                <svg
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }}
                  width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e5e7eb' }}>
                  <th style={{ padding: '12px 16px', width: 40 }}>
                    <input
                      type="checkbox"
                      checked={allData.length > 0 && selectedRows.length === allData.length}
                      onChange={handleSelectAll}
                      style={{ width: 15, height: 15, cursor: 'pointer' }}
                    />
                  </th>
                  <th style={{ padding: '12px 6px', width: 32 }}>
                    <button
                      onClick={() => handleSort('sno')}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af' }}
                    >
                      <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                      </svg>
                    </button>
                  </th>
                  {columns.map((col, i) => (
                    <th
                      key={col}
                      onClick={() => handleSort(colKeys[i])}
                      style={{
                        padding: '12px 14px',
                        textAlign: 'left',
                        fontSize: 12,
                        fontWeight: 700,
                        color: '#374151',
                        textTransform: 'uppercase',
                        letterSpacing: 0.5,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        userSelect: 'none'
                      }}
                    >
                      {col}
                      <SortIcon col={colKeys[i]} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {allData.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columns.length + 2}
                      style={{
                        textAlign: 'center',
                        padding: '56px 20px',
                        color: '#9ca3af',
                        fontSize: 14
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
                        <svg width="40" height="40" fill="none" stroke="#d1d5db" viewBox="0 0 24 24" strokeWidth={1.5}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <span style={{ fontWeight: 500 }}>No data available in table</span>
                        <span style={{ fontSize: 12, color: '#d1d5db' }}>Try adjusting your filters or search criteria</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  allData.map((row, idx) => (
                    <tr
                      key={idx}
                      style={{
                        borderBottom: '1px solid #f3f4f6',
                        background: selectedRows.includes(idx) ? '#eff6ff' : idx % 2 === 0 ? '#fff' : '#fafafa'
                      }}
                    >
                      <td style={{ padding: '10px 16px' }}>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(idx)}
                          onChange={() => handleRowSelect(idx)}
                          style={{ width: 15, height: 15, cursor: 'pointer' }}
                        />
                      </td>
                      <td style={{ padding: '10px 6px' }} />
                      {colKeys.map(key => (
                        <td key={key} style={{ padding: '10px 14px', fontSize: 13, color: '#374151' }}>
                          {row[key] ?? '—'}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={{
            padding: '14px 20px',
            borderTop: '1px solid #f3f4f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 10
          }}>
            <div style={{ fontSize: 13, color: '#6b7280' }}>
              Showing <strong>0</strong> to <strong>0</strong> of <strong>0</strong> entries
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <button
                disabled
                style={{
                  border: '1.5px solid #e5e7eb', borderRadius: 7,
                  padding: '6px 14px', fontSize: 13, fontWeight: 500,
                  color: '#9ca3af', cursor: 'not-allowed', background: '#fafafa',
                  display: 'flex', alignItems: 'center', gap: 5
                }}
              >
                <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
                Previous
              </button>
              <button style={{
                background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                color: '#fff', border: 'none', borderRadius: 7,
                padding: '6px 13px', fontSize: 13, fontWeight: 700,
                cursor: 'pointer', minWidth: 34
              }}>
                1
              </button>
              <button
                disabled
                style={{
                  border: '1.5px solid #e5e7eb', borderRadius: 7,
                  padding: '6px 14px', fontSize: 13, fontWeight: 500,
                  color: '#9ca3af', cursor: 'not-allowed', background: '#fafafa',
                  display: 'flex', alignItems: 'center', gap: 5
                }}
              >
                Next
                <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}